export const DEFAULT_POSITION = {
  lat: -21.21839703484825,
  lng: 55.42781699892731,
}

export const DEFAULT_ZOOM = 14
